import React from 'react';
import { string, number } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Placeholder } from '@thd-olt-component-react/core-ui';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import { AccordionTitleComponent } from './Accordion/AccordionTitleComponent';
import { QAContextProvider } from '../context/QAContext';
import { dataModel } from './dataModel';
import './QuestionsAndAnswers.scss';

export const QuestionsAndAnswersAccordionTitleComponent = ({ itemId, canonicalUrl, seoPageNumber }) => {
  return (
    <div className="grid questions-and-answers" data-component="QuestionsAndAnswersTitle">
      <div className="qa-wrapper">
        <QAContextProvider itemId={itemId} seoPageNumber={seoPageNumber}>
          <QueryProvider cacheKey="question-answer-accordion-title">
            <AccordionTitleComponent itemId={itemId} />
          </QueryProvider>
        </QAContextProvider>
      </div>
    </div>
  );
};

QuestionsAndAnswersAccordionTitleComponent.displayName = 'QuestionsAndAnswersAccordionTitle';

QuestionsAndAnswersAccordionTitleComponent.propTypes = {
  itemId: string.isRequired,
  canonicalUrl: string,
  seoPageNumber: number
};

QuestionsAndAnswersAccordionTitleComponent.defaultProps = {
  canonicalUrl: null,
  seoPageNumber: null
};

QuestionsAndAnswersAccordionTitleComponent.dataModel = dataModel;

const HydratedComponent = withHydrator({
  delay: 2000,
  id: 'questions_answers_accordion_title',
  placeholder: (
    <Placeholder
      type="rect"
      height="50px"
      width="100%"
    />
  ),
  scrollBuffer: 750
}, QuestionsAndAnswersAccordionTitleComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent);

export const QuestionsAndAnswersAccordionTitle = withLayoutGroup({
  name: 'questions_answers_accordion_title'
}, DynamicComponent);

QuestionsAndAnswersAccordionTitle.propTypes = {
  itemId: string.isRequired,
  canonicalUrl: string,
  seoPageNumber: number
};

QuestionsAndAnswersAccordionTitle.defaultProps = {
  canonicalUrl: null,
  seoPageNumber: null
};

QuestionsAndAnswersAccordionTitle.dataModel = dataModel;